import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=1bb9241e&"
import script from "./strategy.vue?vue&type=script&lang=js&"
export * from "./strategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "strategy.vue"
export default component.exports